import store from "@/store/index";

export default {
  checkMonitorsEnabledPermissions(to, from, next) {
    next((vm) => {
      // make sure monitors are enabled before going to a monitor route
      if (store.getters["monitorsEnabled"]) {
        next();
      } else {
        // monitors not enabled, just go home
        next("/");
      }
    });
  },
};
